import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

// TODO DREGAB-11988 Poprawić działanie propa "size"
export const StyledNumberInput = styled(NumberInput)`
   > div:nth-child(2) {
      max-width: 84px;
   }
`;

StyledNumberInput.displayName = 'StyledNumberInput';
